export default async function copyId(val) {
  try {
    await navigator.clipboard.writeText(String(val ?? ''));
    return true; // copied
  } catch {
    return false; // failed
  }
}
